export default __webpack_public_path__ + "static/big-logo-ib-667da0ed3be9b738fa971afe68dee89c.jpg";